import React, { useState, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import i18n from 'live/services/i18n'
import Filters from '../../../../common/components/FilterSelectorDropdown'
import { TYPE_VALUE_FILTERS } from '../../../../common/components/FilterSelectorDropdown/constants'
import Scrollbars from 'react-scrollbars-custom'

import { MenuItem, Dropdown } from 'react-bootstrap'
import listenForOutsideClicks from '../../../../common/listenForOutsideClicks'

import { OptionType } from '../../../../common/types/options'

import {
    Header,
    Label,
    Title,
    ReportName,
    ReportStatus,
    Author,
    LastExecution,
    EditStatus,
    Actions,
    StyledSearchAndFilter
} from './styles'
import { FilterOption, ReportListHeaders, SortOption, getDefaultSearchFilter, handleSearchOnChange } from '../helper'

import { SearchBar } from '@intelie/ui'
import { CREATE_NEW_REPORT } from '../../reportLinks'

interface ReportListHeaderProps {
    selectedFilters: FilterOption[]
    selectedSorter: SortOption
    onChangeFilters: (newFilters: FilterOption[]) => void
    onChangeSorter: (newSorter: SortOption) => void
    filterOptions: FilterOption[]
}

export default function ReportListHeader({
    selectedFilters,
    selectedSorter,
    onChangeFilters,
    onChangeSorter,
    filterOptions
}: ReportListHeaderProps): JSX.Element {
    const [filterDropdownOpen, setFilterDropdownOpen] = useState(false)

    const refMenu = useRef()

    const searchFilter =
        selectedFilters.find(f => f?.header === ReportListHeaders.REPORT_NAME) ?? getDefaultSearchFilter()
    const searchValue = searchFilter.options[0].value ?? ''

    //TODO CLICK OUTSIDE TO CLOESE
    // useEffect(
    //     listenForOutsideClicks(filterDropdownOpen, refMenu, () => setFilterDropdownOpen(false)),
    //     [filterDropdownOpen]
    // )

    const handleChangeSorter = (filterField: ReportListHeaders) => {
        if (selectedSorter?.field === filterField)
            onChangeSorter({ ...selectedSorter, reverse: !selectedSorter.reverse })
        else onChangeSorter({ field: filterField, reverse: false })
    }

    return (
        <div>
            <Title>ALL REPORTS</Title>
            <StyledSearchAndFilter>
                <div className="report-create-button">
                    <Link
                        className="btn btn-primary btn-report-create-button"
                        to={{
                            pathname: '/generalinformation/new'
                        }}
                        disabled={!CREATE_NEW_REPORT}
                    >
                        <div className="btn-report-create-button-content">
                            <i className="far fa-fw fa-plus" />
                            <span>New Report</span>
                        </div>
                    </Link>
                </div>
                <div className="report-search">
                    <SearchBar
                        className="report-search-serachbar"
                        filteredValue={searchValue}
                        placeholder={i18n('Search for a report')}
                        handleFilter={value => {
                            onChangeFilters(handleSearchOnChange(value || '', [...selectedFilters]))
                        }}
                        debounceWait={200}
                    />
                </div>
                <div className="report-filter-selector">
                    <Dropdown id="report-filter-dropdown" open={filterDropdownOpen} pullRight={true} ref={refMenu}>
                        <div
                            className="report-filter-button-dropdown-content"
                            onClick={() => setFilterDropdownOpen(!filterDropdownOpen)}
                        >
                            <i className="far fa-filter report-filter-button-dropdown-icon" />
                            <span className="report-filter-button-dropdown-label">{i18n('Filter')}</span>
                        </div>

                        <Dropdown.Menu aria-labelledby="dropdownMenuButton">
                            <div className="report-filter-dropdown-menu-content-container">
                                {/* <Scrollbars maximalThumbSize={90}
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        marginBottom: '2px'
                                    }}
                                > */}
                                <div className="report-filter-dropdown-content-container">
                                    <div className="report-filter-dropdown-content-header">
                                        <label>{i18n('Filter by: ')}</label>
                                    </div>
                                    <Filters
                                        className={'report-filter-selectors-container'}
                                        list={filterOptions.map(fo => {
                                            return {
                                                label: fo.header.toString(),
                                                value: fo.header.toString(),
                                                fillOptions: true,
                                                type: TYPE_VALUE_FILTERS.SELECT,
                                                format: 'string'
                                            }
                                        })}
                                        values={selectedFilters
                                            .filter(
                                                f =>
                                                    ![
                                                        ReportListHeaders.REPORT_NAME,
                                                        ReportListHeaders.LAST_EXECUTION
                                                    ].includes(f?.header)
                                            )
                                            .map(sf => ({ key: sf?.header, value: sf?.options ?? [] }))
                                            .reduce((r, c) => ({ ...r, [c.key]: c.value }), {})}
                                        options={filterOptions
                                            .filter(
                                                f =>
                                                    ![
                                                        ReportListHeaders.REPORT_NAME,
                                                        ReportListHeaders.LAST_EXECUTION
                                                    ].includes(f?.header)
                                            )
                                            .map(sf => ({ key: sf?.header, value: sf?.options ?? [] }))
                                            .reduce((r, c) => ({ ...r, [c.key]: c.value }), {})}
                                        handleChange={(fieldHeader: ReportListHeaders, op: OptionType<string>) => {
                                            let currentFilterIdx = selectedFilters.findIndex(
                                                f => f.header === fieldHeader
                                            )
                                            const newFilters = [...selectedFilters]
                                            if (currentFilterIdx === -1) {
                                                currentFilterIdx = newFilters.length
                                                newFilters.push({ header: fieldHeader, options: [] } as FilterOption)
                                            }
                                            if (op?.value === undefined) newFilters.splice(currentFilterIdx, 1)
                                            else newFilters[currentFilterIdx].options = [{ ...op }]

                                            onChangeFilters(newFilters)
                                        }}
                                    />
                                </div>
                                {/* </Scrollbars> */}
                            </div>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </StyledSearchAndFilter>
            <Header>
                <ReportName onClick={() => handleChangeSorter(ReportListHeaders.REPORT_NAME)}>
                    <Label>
                        {ReportListHeaders.REPORT_NAME}
                        {selectedSorter.field === ReportListHeaders.REPORT_NAME ? (
                            <i
                                className={`fa fa-arrow-${selectedSorter.reverse ? 'down' : 'up'}`}
                                style={{ marginLeft: '4px' }}
                            />
                        ) : null}
                    </Label>
                </ReportName>
                <Author onClick={() => handleChangeSorter(ReportListHeaders.AUTHOR)}>
                    <Label>
                        {ReportListHeaders.AUTHOR}
                        {selectedSorter.field === ReportListHeaders.AUTHOR ? (
                            <i
                                className={`fa fa-arrow-${selectedSorter.reverse ? 'down' : 'up'}`}
                                style={{ marginLeft: '4px' }}
                            />
                        ) : null}
                    </Label>
                </Author>
                <LastExecution onClick={() => handleChangeSorter(ReportListHeaders.LAST_EXECUTION)}>
                    <Label>
                        {ReportListHeaders.LAST_EXECUTION}
                        {selectedSorter.field === ReportListHeaders.LAST_EXECUTION ? (
                            <i
                                className={`fa fa-arrow-${selectedSorter.reverse ? 'down' : 'up'}`}
                                style={{ marginLeft: '4px' }}
                            />
                        ) : null}
                    </Label>
                </LastExecution>
                <ReportStatus onClick={() => handleChangeSorter(ReportListHeaders.REPORT_STATUS)}>
                    <Label>
                        {ReportListHeaders.REPORT_STATUS}
                        {selectedSorter.field === ReportListHeaders.REPORT_STATUS ? (
                            <i
                                className={`fa fa-arrow-${selectedSorter.reverse ? 'down' : 'up'}`}
                                style={{ marginLeft: '4px' }}
                            />
                        ) : null}
                    </Label>
                </ReportStatus>
                <EditStatus onClick={() => handleChangeSorter(ReportListHeaders.EDITING_STATUS)}>
                    <Label>
                        {ReportListHeaders.EDITING_STATUS}
                        {selectedSorter.field === ReportListHeaders.EDITING_STATUS ? (
                            <i
                                className={`fa fa-arrow-${selectedSorter.reverse ? 'down' : 'up'}`}
                                style={{ marginLeft: '4px' }}
                            />
                        ) : null}
                    </Label>
                </EditStatus>
                <Actions />
            </Header>
        </div>
    )
}
